import { render, staticRenderFns } from "./settings-profile.vue?vue&type=template&id=314b00ed&scoped=true&"
import script from "./settings-profile.ts?vue&type=script&lang=ts&"
export * from "./settings-profile.ts?vue&type=script&lang=ts&"
import style0 from "./settings-profile.vue?vue&type=style&index=0&id=314b00ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b00ed",
  null
  
)

export default component.exports